// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-color {
  color: #0f5597;
}

.font-sze {
  font-size: medium;
}

.font-sze-large {
  font-size: x-large;
}

.font-600 {
  font-weight: 500 !important;
}

.current-info .info-item-label {
  color: #0f5597 !important;
  font-weight: 450 !important;
}

.center-items-container {
  display: flex;
  justify-content: space-around;
}

.spread-items-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.align-end {
  text-align: end;
}

.spaced {
  margin-left: 15px;
}

.limited-width {
  max-width: 700px;
}

#info {
  width: 100%;
  min-width: -moz-fit-content;
  min-width: fit-content;
}

.ballotarray {
  list-style: none;
}

.row {
  display: flex;
  flex-direction: row;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/current-committee-information/current-committee-information.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAGI;EACI,yBAAA;EACA,2BAAA;AAAR;;AAIA;EACI,aAAA;EACA,6BAAA;AADJ;;AAIA;EACI,aAAA;EACA,8BAAA;EACA,WAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,WAAA;EACA,2BAAA;EAAA,sBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;AADJ","sourcesContent":[".text-color {\n    color: #0f5597;\n}\n\n.font-sze {\n    font-size: medium;\n}\n\n.font-sze-large {\n    font-size: x-large;\n}\n\n.font-600 {\n    font-weight: 500 !important;\n}\n\n.current-info {\n    .info-item-label {\n        color: #0f5597 !important;\n        font-weight: 450 !important;\n    }\n}\n\n.center-items-container {\n    display: flex;\n    justify-content: space-around;\n}\n\n.spread-items-container {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.align-end {\n    text-align: end;\n}\n\n.spaced {\n    margin-left: 15px;\n}\n\n.limited-width {\n    max-width: 700px;\n}\n\n#info {\n    width: 100%;\n    min-width: fit-content;\n}\n\n.ballotarray {\n    list-style: none;\n}\n\n.row {\n    display: flex;\n    flex-direction: row;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
